_collow.components.NotificationConnection = class NotificationConnection extends (
  _collow.components.Base
) {
  root;
  params;
  websocket;
/* TODO: activate the code again when notifications are being implemented, it was deactivated because of the websocket
  constructor(root, _, params) {
    super();
    this.root = root;
    this.params = params;

    localStorage.removeItem("notifications");
    this.listen(document.body, "_collow.notifications.change", ({ detail }) => {
      this.websocket.send(
        JSON.stringify({
          type: "read",
          ids: detail.readMessage.id,
        })
      );
    });

    const url = params.path.slice(params.path.indexOf("/"));
    const token = localStorage?.getItem("token")?.split(" ")?.[1];
    if (!token) return;

    try {
      this.websocket = new WebSocket(`ws:${url}/websocket`);
      this.websocket.onopen = () => {
        this.websocket.send(
          JSON.stringify({
            type: "auth",
            token,
          })
        );
      };

      this.websocket.onmessage = this.messageHandler;

      this.websocket.onerror = (err) => {
        console.log(err);
      };
    } catch (err) {
      console.log(err);
    }

    onbeforeunload = () => this.websocket.close();

    this.listen(
      document.body,
      ["change.localstorage", "_collow.notifications.change"],
      this.notificationAlertChecker
    );
  }

  messageHandler = ({ data }) => {
    const notification = JSON.parse(data);
    if (notification.type == "auth") return;
    const currentNotifications = localStorage.getItem("notifications")
      ? JSON.parselocalStorage.getItem("notifications")
      : [];
    const notificationsArray = [notification, ...currentNotifications];
    localStorage.setItem("notifications", JSON.stringify(notificationsArray));
    this.notificationAlertChecker();
  };

  notificationAlertChecker = () => {
    const notifications = JSON.parse(localStorage.getItem("notifications"));
    if (!notifications) return;
    const newMessages = notifications.find((message) => message.read == false);
    this.root.dataset.newNotification = newMessages ? true : false;
  }; */
};
